"use strict";

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.object.define-property");

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("../utils/base");

var spacing_1 = require("./spacing");

var colors_1 = require("./colors");

var fontWeight_1 = require("./fontWeight"); // general


var defaultFontSize = base_1.convertPixelsToRem(16);
var defaultFontFamily = 'Lato';
var fontWeightRegular = fontWeight_1.fontWeight.regular;
var fontWeightBold = fontWeight_1.fontWeight.bold;
var fallbackDefaultFonts = ['"Helvetica Neue"', 'Helvetica', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', '"PingFang SC"', '"Hiragino Sans GB"', '"Microsoft YaHei"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'];
var fallbackDefaultCodeFonts = ['SFMono-Regular', 'Consolas', '"Liberation Mono"', 'Menlo', 'Courier', 'monospace']; // headlines

var headlineFontFamily = defaultFontFamily;
var h1 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(46),
  lineHeight: base_1.convertPixelsToRem(50),
  fontWeight: fontWeightBold
};
var h2 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(36),
  lineHeight: base_1.convertPixelsToRem(40),
  fontWeight: fontWeightBold
};
var h3 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(30),
  lineHeight: base_1.convertPixelsToRem(36),
  fontWeight: fontWeightBold
};
var h4 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(24),
  lineHeight: base_1.convertPixelsToRem(28),
  fontWeight: fontWeightBold
};
var h5 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(18),
  lineHeight: base_1.convertPixelsToRem(22),
  fontWeight: fontWeightBold
};
var h6 = {
  fontFamily: __spreadArrays([headlineFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(13),
  lineHeight: base_1.convertPixelsToRem(18),
  fontWeight: fontWeightRegular
}; // body

var bodyFontFamily = defaultFontFamily;
var bodyJumbo = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(24),
  lineHeight: base_1.convertPixelsToRem(36)
};
var bodyBig = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(18),
  lineHeight: base_1.convertPixelsToRem(27)
};
var body = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(16),
  lineHeight: base_1.convertPixelsToRem(22)
};
var bodyBold = {
  fontFamily: body.fontFamily,
  fontSize: body.fontSize,
  lineHeight: body.lineHeight,
  fontWeight: fontWeightBold
};
var bodySmall = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(14),
  lineHeight: base_1.convertPixelsToRem(20)
};
var bodySmallBold = {
  fontFamily: bodySmall.fontFamily,
  fontSize: bodySmall.fontSize,
  lineHeight: bodySmall.lineHeight,
  fontWeight: fontWeightBold
};
var bodyMicro = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(13),
  lineHeight: base_1.convertPixelsToRem(18)
};
var notification = {
  fontFamily: __spreadArrays([bodyFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(14),
  lineHeight: base_1.convertPixelsToRem(18)
};
var notificationBold = {
  fontFamily: notification.fontFamily,
  fontSize: notification.fontSize,
  lineHeight: notification.lineHeight,
  fontWeight: fontWeightBold
}; // attribution

var attributionFontFamily = 'Volkhov';
var quote = {
  fontFamily: __spreadArrays([attributionFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(30),
  lineHeight: base_1.convertPixelsToRem(42),
  fontWeight: fontWeightRegular
};
var author = {
  fontFamily: __spreadArrays([attributionFontFamily], fallbackDefaultFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(18),
  lineHeight: base_1.convertPixelsToRem(36)
}; // code

var codeFontFamily = 'Roboto Mono';
var code = {
  fontFamily: __spreadArrays([codeFontFamily], fallbackDefaultCodeFonts).join(', '),
  fontSize: base_1.convertPixelsToRem(13),
  lineHeight: base_1.convertPixelsToRem(18),
  contrastBackgroundColor: colors_1.color.N10,
  contrastColor: colors_1.color.N5,
  padding: spacing_1.spacing.lg
};

function getFontImportsURL() {
  var defaultFont = defaultFontFamily + ":" + [fontWeight_1.fontWeight.regular, fontWeight_1.fontWeight.bold].join(',');
  var attrFont = attributionFontFamily + ":" + [fontWeight_1.fontWeight.regular, fontWeight_1.fontWeight.bold].join(',');
  var codeFont = codeFontFamily + ":" + [fontWeight_1.fontWeight.regular, fontWeight_1.fontWeight.bold].join(',');
  return "https://fonts.googleapis.com/css?family=" + [defaultFont, attrFont, codeFont].join('|');
}

exports.getFontImportsURL = getFontImportsURL;
exports.typography = {
  // general
  fontSize: defaultFontSize,
  fontFamily: defaultFontFamily,
  fontWeightRegular: fontWeightRegular,
  fontWeightBold: fontWeightBold,
  // headlines
  headlineFontFamily: headlineFontFamily,
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
  // body
  bodyJumbo: bodyJumbo,
  bodyBig: bodyBig,
  body: body,
  bodyBold: bodyBold,
  bodySmall: bodySmall,
  bodySmallBold: bodySmallBold,
  bodyMicro: bodyMicro,
  notification: notification,
  notificationBold: notificationBold,
  // attribution
  attributionFontFamily: attributionFontFamily,
  quote: quote,
  author: author,
  // code
  codeFontFamily: codeFontFamily,
  code: code
};